module.exports = __webpack_public_path__ + "img/preceiro.9ea779c1.png";